import { ApiRequestFilters } from '../../../shared/types/api-request-filters';
import { TagRecordCategoryEnum } from '../enums/tag-record-category.enum';

/**
 * Tags filters
 */
export class TagsFilters extends ApiRequestFilters {
	/**
	 * Record category values
	 */
	recordCategories?: TagRecordCategoryEnum[];
}
